export interface GoogleFontWithWeights {
  family: string;
  weights: Set<string>;
}

const buildWeightAxis = (weights: Iterable<string>): string => {
  const validWeights = Array.from(
    new Set(
      Array.from(weights, w => Number.parseInt(String(w), 10)).filter(
        n => Number.isInteger(n) && n >= 100 && n <= 900 && n % 100 === 0,
      ),
    ),
  ).sort((a, b) => a - b);

  if (validWeights.length === 0) return "";

  const isFullRange =
    validWeights.length === 9 &&
    validWeights[0] === 100 &&
    validWeights[8] === 900;
  return isFullRange ? "wght@100..900" : `wght@${validWeights.join(";")}`;
};

export const generateGoogleFontsLinks = (
  fonts: Map<string, GoogleFontWithWeights>,
): string => {
  if (!fonts || fonts.size === 0) return "";

  const families = Array.from(fonts.values())
    .map(({ family, weights }) => {
      const name = family.trim();
      if (!name) return null;

      const axis = buildWeightAxis(weights);
      return axis ? `${name}:${axis}` : name;
    })
    .filter((v): v is string => !!v)
    .sort((a, b) => a.localeCompare(b));

  if (families.length === 0) return "";

  const familiesParam = families.join("&family=");
  const cssUrl = `https://fonts.googleapis.com/css2?family=${familiesParam}&display=swap`;

  return `
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="${cssUrl}" rel="stylesheet">`.trim();
};
